import React from 'react';
import './Tours2.css';

const TEXTS = {
  de: {
    downloadPdf: 'PDF herunterladen',
    noTours: 'Keine Reisen verfügbar',
    defaultHeading: 'Unsere Reisen'
  },
  en: {
    downloadPdf: 'Download PDF',
    noTours: 'No tours available',
    defaultHeading: 'Our Tours'
  },
  it: {
    downloadPdf: 'Scarica PDF',
    noTours: 'Nessun tour disponibile',
    defaultHeading: 'I nostri tour'
  }
};

const Tours2 = ({ tours, heading, language = 'de' }) => {
  const t = TEXTS[language] || TEXTS.de;

  return (
    <section className="tours2-section">
      <div className="tours2-container">
        <h2 className="tours2-title">{heading || t.defaultHeading}</h2>
        
        {tours && tours.length > 0 ? (
          <div className="tours2-grid">
            {tours.map((tour) => (
              <div key={tour.id} className="tours2-card">
                <div className="tours2-card-header">
                  <div className="tours2-icon">📍</div>
                  <h3 className="tours2-card-title">{tour.title}</h3>
                </div>
                {tour.subtitle && (
                  <p className="tours2-card-subtitle">{tour.subtitle}</p>
                )}
                {tour.description && (
                  <p className="tours2-card-description">{tour.description}</p>
                )}
                {tour.pdf_filename && (
                  <a 
                    className="tours2-pdf"
                    href={`/tour-pdfs/${tour.pdf_filename}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t.downloadPdf}
                  </a>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="tours2-empty">{t.noTours}</p>
        )}
      </div>
    </section>
  );
};

export default Tours2;
